import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
// PAYMENT DISABLED - Keep for future re-enablement
// import SubscribeModal from '@/components/billing/SubscribeModal'

interface AuthGuardProps {
  children: ReactNode
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { user, profile, isLoading } = useAuthStore()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    )
  }

  // Not logged in
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Wait for profile to load before checking subscription
  if (!profile) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    )
  }

  // Account disabled
  if (profile?.is_disabled) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="card max-w-md text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Account Disabled</h2>
          <p className="text-gray-600 mb-4">
            Your account has been disabled. Please contact support for assistance.
          </p>
          <button
            onClick={() => useAuthStore.getState().signOut()}
            className="btn-secondary"
          >
            Sign Out
          </button>
        </div>
      </div>
    )
  }

  // PAYMENT DISABLED - Allow all authenticated users
  // Keep subscription check code for future re-enablement when we have paying clients
  /*
  // Check subscription status
  const isSubscriptionValid = () => {
    if (!profile) return false

    const { subscription_status, trial_ends_at, current_period_end } = profile

    if (subscription_status === 'active') {
      // Check if still within billing period
      if (current_period_end) {
        return new Date(current_period_end) > new Date()
      }
      return true
    }

    if (subscription_status === 'trialing') {
      // Check if trial is still valid
      if (trial_ends_at) {
        return new Date(trial_ends_at) > new Date()
      }
      return false
    }

    if (subscription_status === 'canceled') {
      // Check if still within grace period
      if (current_period_end) {
        return new Date(current_period_end) > new Date()
      }
      return false
    }

    return false
  }

  // Show subscription modal if subscription is not valid
  if (!isSubscriptionValid()) {
    return (
      <>
        {children}
        <SubscribeModal isOpen={true} />
      </>
    )
  }
  */

  return <>{children}</>
}
